import Service from '@ember/service';
import ENV from 'bullitt-time-live/config/environment';

export default class AjaxService extends Service
{
	host = ENV.APP.ajaxHost;

	async request(url)
	{
		try {
			const response = await fetch(this.host + url, { cache: "no-store" });
			if (!response.ok) {
				throw new Error(`HTTP error: ${response.status}`);
			}
			return await response.json();
		} catch (error) {
			console.error(`Ajax request failed for ${url}:`, error);
			throw error;
		}
	}
}